import { render, staticRenderFns } from "./Data.vue?vue&type=template&id=0f266baa"
import script from "./Data.vue?vue&type=script&lang=js"
export * from "./Data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports